import styles from './index.module.scss';
import { observer } from 'mobx-react';
import { reduceStore } from './store';
import { useSearchParams } from 'react-router-dom';
import { Step1 } from './Step1';
import { Step2 } from './Step2';
import { Step3 } from './Step3';
import { useEffect } from 'react';
import { Steps } from 'antd';
import { useDevice } from '../../hooks/useDevice';

export const Reduce = observer(function () {
    const [qs] = useSearchParams();

    useEffect(() => {
        const orderNo = qs.get('o') || '';
        if (orderNo) {
            reduceStore.init({ orderNo });
        }
        return () => {
            reduceStore.init();
        };
    }, []);

    const { isMobile } = useDevice();

    return (
        <div className={`${styles.reduce} pt-4`}>
            <div className={`${styles.new} bg-white`}>
                <div className={''}>
                    <div className={`mx-auto w-full py-3 md:w-[80%] md:py-4 ${styles.stepsBar}`}>
                        <Steps
                            current={reduceStore.curStep}
                            onChange={reduceStore.onNewStepChange}
                            className={'site-navigation-steps'}
                            items={reduceStore.steps}
                            direction="horizontal"
                            labelPlacement={isMobile ? 'vertical' : 'horizontal'}
                            responsive={false}
                            style={{
                                flexDirection: isMobile ? 'row' : '',
                            }}
                        />
                    </div>

                    <div className={styles.content}>
                        {reduceStore.curStep === 0 && <Step1 />}
                        {reduceStore.curStep === 1 && <Step2 />}
                        {reduceStore.curStep === 2 && <Step3 />}
                    </div>
                </div>
            </div>
        </div>
    );
});
